import React from 'react'
import {useEffect, useState} from 'react'
import Button from '../Button'
import envVariables from '../../data/envVariables'
import usePost from '../../hooks/usePost'
import format from "date-fns/format"
import PortalOpsStageBasedCtas from './PortalOpsStageBasedCtas'
import PortalTailNumberInput from './PortalTailNumberInput'
import { kycHeatList, wifiList, cateringList, yesNoList } from '../../data/portalFormListData'
import SelectInput from '../SelectInput'
import { isDealPreAvinode } from '../../utilities/settings'
import { currencyList } from '../../data/currencyList'
import TextInput from '../TextInput'
import NumberInput from '../NumberInput'
import PortalVipTerminalInput from './PortalVipTerminalInput'
import LoadingOverlay from '../LoadingOverlay'
import TextAreaInput from '../TextAreaInput'

const PortalOpsDetails = ({deal, legs}) => {
    const {sending, returnMessage, postData} = usePost()

    const legId = deal.daM_Ref
    const pricesUrl = `${envVariables.documentBase}/prices?lo=${legId}`
    const builderUrl = `${envVariables.documentBase}/QuoteBuilder?lo=${legId}`

    const [didSetDeal, setDidSetDeal] = useState(false)
    
    const [paramLegs, setParamLegs] = useState(legs)
    const [aircraftTail, setAircraftTail] = useState('')
    const [aircraftOp, setAircraftOp] = useState('')
    const [aircraftType, setAircraftType] = useState('')
    const [aircraftCat, setAircraftCat] = useState('')

    const [selectedPrefCurrency, setSelectedPrefCurrency] = useState('')
    const [selMovida, setSelMovida] = useState('')
    const [selectedKycHeat, setSelectedKycHeat] = useState('')
    const [currentNotes, setCurrentNotes] = useState('')
    const [numPets, setNumPets] = useState(0)

    const [selectedWifi, setSelectedWifi] = useState('')
    const [selectedCatering, setSelectedCatering] = useState('')
    const [currentOpsNotes, setCurrentOpsNotes] = useState('')

    const [contractName, setContractName] = useState('')

    const [leg1TerminalFrom, setLeg1TerminalFrom] = useState('')
    const [leg1TerminalTo, setLeg1TerminalTo] = useState('')
    const [leg2TerminalFrom, setLeg2TerminalFrom] = useState('')
    const [leg2TerminalTo, setLeg2TerminalTo] = useState('')

    const [numPilots, setNumPilots] = useState(0)
    const [numFuelStops, setNumFuelStops] = useState(0)

    const [hasFlightAttendant, setHasFlightAttendant] = useState('')
    const [FFOverride, setFFOverride] = useState(false)

    useEffect(() => {
        if(deal && !didSetDeal) {
            setAircraftTail(deal.tail_No)
            setAircraftOp((deal.flight_Operator_Test && deal.flight_Operator_Test.length > 0) ? deal.flight_Operator_Test[0] : '')
            setAircraftType(deal.aircraft_Type_NEW)
            setAircraftCat(deal.aircraft_Category_NEW)

            setSelectedPrefCurrency(deal.preferred_Currency)
            setSelectedKycHeat(deal.kyC_Heat)
            setSelMovida(deal.show_MOVIDA_in_Quote)
            setCurrentNotes(deal.notes_on_Flight)
            setNumPets(deal.number_of_Pets ? parseInt(deal.number_of_Pets) : 0)

            setSelectedWifi(deal.wiFi)
            setSelectedCatering(deal.catering_option)
            setCurrentOpsNotes(deal.catering)

            setContractName(deal.contract_Display_Name)

            setNumPilots(deal.pilots ?? 0)
            setNumFuelStops(deal.fuel_Stops ?? 0)

            setHasFlightAttendant(deal.has_Flight_Attendant)

            setFFOverride(deal.fF_override)

            setDidSetDeal(true)
        }
    }, [deal])

    const updateTail = (newTail) => {
        setAircraftTail(newTail.id)
        setAircraftOp(newTail.operatorName)
        setAircraftType(newTail.aircraftName)
        setAircraftCat(newTail.category)
    }

    const openPricesPage = () => {
        window.open(pricesUrl)
    }
    const openQuoteBuilder = () => {
        window.open(builderUrl)
    }

    const updateDeal = () => {
        let formData = {}

        formData = {
            dealId: deal.id,
            KYC_Heat: selectedKycHeat,
            Preferred_Currency: selectedPrefCurrency,
            Show_MOVIDA_in_Quote: selMovida,
            Number_of_Pets: numPets,
            Notes_on_Flight: currentNotes ?? '',
            WiFi: selectedWifi,
            catering_option: selectedCatering,
            Catering: currentOpsNotes ?? '',

            Flight_Operator_Test: [aircraftOp],
            Aircraft_Type_NEW: aircraftType,
            Aircraft_Category_NEW: aircraftCat,
            Tail_No: aircraftTail,

            Contract_Display_Name: contractName,

            Leg_1_from_terminal: leg1TerminalFrom,
            Leg_1_Airport_To_terminal: leg1TerminalTo,

            Pilots: numPilots,
            Fuel_Stops: numFuelStops,

            Has_Flight_Attendant: hasFlightAttendant,
            FF_override: FFOverride
        }

        if(leg2TerminalFrom) {
            formData.Leg_2_Airport_From_terminal = leg2TerminalFrom
        }
        if(leg2TerminalTo) {
            formData.Leg_2_Airport_To_terminal = leg2TerminalTo
        }

        postData(formData, '/api/portal/update-deal')

        //console.log(formData)
    }

    return (deal && 
        <>
        <div className='deal_details_form'>
            <div>
                <div className='formRow'>
                    <label>Date opened:</label> {format(new Date(deal.date_Opened), 'dd/MM/yyyy')}
                </div>
                <div className='formRow'>
                <label>Preferred currency:</label> 
                    
                    <SelectInput
                        options={currencyList}
                        value={(value) => setSelectedPrefCurrency(value)}
                        defaultValue={deal.preferred_Currency}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    />
                </div>
                <div className='formRow'>
                    <label>KYC heat:</label> 
                    <SelectInput
                            value={(value) => setSelectedKycHeat(value)}
                            options={kycHeatList}
                            label=''
                            required
                            defaultValue={deal.kyC_Heat}
                            classNames={['select-input--full select-input--form']}
                        />
                </div>
                <div className='formRow'>
                    <label>Show Movida:</label> <input type='checkbox' 
                        onChange={(e) => setSelMovida(e.target.checked)}
                        defaultChecked={deal.show_MOVIDA_in_Quote} 
                        name='show_MOVIDA_in_Quote' />
                </div>
                <div className='formRow'>
                    <label>Contract name:</label> 
                    <TextInput 
                        defaultValue={contractName}
                        label=''
                        value={(fromValue) => setContractName(fromValue)}
                    />
                </div>
                <div className='formRow'>
                    <label>Wifi:</label> <SelectInput
                        options={wifiList}
                        value={(value) => setSelectedWifi(value)}
                        defaultValue={deal.wiFi}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    /></div>
                <div className='formRow'>
                    <label>Pilots:</label>
                    <NumberInput 
                        label=''
                        defaultValue={numPilots}
                        value={(newValue)=> setNumPilots(newValue)}
                    />
                </div>
                <div className='formRow'>
                    <label>Has Flight Attendant: </label>
                    <SelectInput
                            value={(value) => setHasFlightAttendant(value)}
                            options={yesNoList}
                            label=''
                            required
                            defaultValue={deal.has_Flight_Attendant}
                            classNames={['select-input--full select-input--form']}
                        />
                </div>
                <div className='formRow'>
                    <label>Catering:</label> <SelectInput
                        options={cateringList}
                        value={(value) => setSelectedCatering(value)}
                        defaultValue={deal.wiFi}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    />
                </div>
                <div className='formRow'>
                    <label>Fuel stops:</label> 
                    <NumberInput
                        label=''
                        defaultValue={numFuelStops}
                        value={(newValue) => setNumFuelStops(newValue)}
                    />
                </div>
                <div className='formRow'>
                    <label>Ops Notes:</label>
                    <TextAreaInput
                        defaultValue={deal.catering}
                        value={(fromValue) => setCurrentOpsNotes(fromValue)}
                        label=''
                    /> 
                </div>
                <div className='formRow'>
                    <label>FF Override:</label> <input type='checkbox' 
                        onChange={(e) => setFFOverride(e.target.checked)}
                        defaultChecked={deal.fF_override} 
                        name='fF_override' />
                    
                </div>
                <div className='formRow'><label>Operator:</label> {aircraftOp}</div>
                <div className='formRow'><label>Aircraft Type:</label> {aircraftType}</div>
                <div className='formRow'><label>Aircraft Category:</label> {aircraftCat}</div>
                <div className='formRow'><label>Tail:</label> {aircraftTail}</div>
                <div className='formRow'><label>Change tail: </label> 
                    <PortalTailNumberInput 
                        defaultValue={aircraftTail}
                        value={(fromValue) => updateTail(fromValue)}
                    />
                </div>
            </div>
            <div>
                <div className='formRow'>
                    <label>Tenant:</label> {deal.tenantID}
                </div>
                <div className='formRow'>
                    <label>Service:</label> {deal.service}
                </div>
                <div className='formRow'>
                    <label>Trip type:</label> {paramLegs.length === 1 ? 'Single' : paramLegs.length === 2 ? 'Return' : 'Multi-leg'}
                </div>
                <div className='formRow'>
                    <label>Notes:</label>
                    <TextAreaInput
                        defaultValue={deal.notes_on_Flight}
                        value={(fromValue) => setCurrentNotes(fromValue)}
                        label=''
                    />
                </div>
                <div className='formRow'>
                    <label>Num Pets:</label> 
                    <fieldset class="fieldset fieldset--margin-bottom">
                        <div class="text-input text-input--margin-bottom">
                            <input type="text" autocomplete="on" class="text-input__input" defaultValue={deal.number_of_Pets ?? 0}  onChange={(e) => setNumPets(parseInt(e.target.value))} />
                            <label class="label label--minimised"></label>
                        </div>
                    </fieldset>
                </div>
                <div className='formRow'>
                    <label>SHYF number:</label> {deal.shyF_No}
                </div>
                {(deal && !isDealPreAvinode(deal)) &&
                <>
                    <div className='formRow'>
                        <label>Leg 1 terminal from:</label> 
                        <PortalVipTerminalInput 
                            value={(fromValue) => setLeg1TerminalFrom(fromValue.name)}
                        />
                    </div>
                    <div className='formRow'>
                        <label>Leg 1 terminal to:</label>  
                        <PortalVipTerminalInput 
                            value={(fromValue) => setLeg1TerminalTo(fromValue.name)}
                        />
                    </div>

                    {(paramLegs.length > 1) && 
                        <>
                            <div className='formRow'>
                                <label>Leg 2 terminal from:</label> 
                                <PortalVipTerminalInput 
                                />
                            </div>
                            <div className='formRow'>
                                <label>Leg 2 terminal to:</label>  
                                <PortalVipTerminalInput 
                                />
                            </div>
                        </>
                    }
                </>
                }
            </div>
        </div>
         <div className='deal_details_form'>
            <Button classNames={['button--tertiary']} onClick={() => updateDeal()}>Save changes</Button>
        </div>

        {paramLegs && !isDealPreAvinode(deal) &&
                <>
                <div className='deal_details_form'>
                    <div>
                        {paramLegs && !isDealPreAvinode(deal) && paramLegs.sort((a, b) => {return a.leg_Number < b.leg_Number ? -1 : 1}).map((leg, index) => {
                            return (
                                <>
                                <div className='formRow'>
                                    <strong><em>Leg {index+1}</em></strong>
                                </div>
                                <div className='formRow'>
                                    <label>From:</label> {leg.airport_From}
                                </div>
                                <div className='formRow'>
                                    <label>To:</label> {leg.airport_To}
                                </div>
                                <div className='formRow'>
                                    <label>Date:</label> {format(new Date(leg.leg_Date_and_Time), 'dd/MM/yyyy HH:mm')}
                                </div>
                                {(deal.leg_1_Date_of_Arrival && index === 0) && 
                                    <div className='formRow'>
                                        <label>Arrival date/time:</label> {format(new Date(deal.leg_1_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_1_Time_of_Arrival}
                                    </div>
                                }
                                {(deal.leg_2_Date_of_Arrival && index === 1) && 
                                    <div className='formRow'>
                                        <label>Arrival date/time:</label> {format(new Date(deal.leg_2_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_2_Time_of_Arrival}
                                    </div>
                                }
                                <div className='formRow'>
                                    <label>Pax:</label> {leg.number_of_Passengers}
                                </div>
                                <div className='formRow'>
                                    <label>Bags:</label> {leg.number_of_Bags}
                                </div>
                                </>
                            )
                        })} 
                    </div>
                </div>
                </>
            }

        {(deal) && 
            <PortalOpsStageBasedCtas 
                deal={deal} 
            />
        }
        {sending && 
            <LoadingOverlay />
        }
        </>
    )
}

export default PortalOpsDetails